import { Alert, Typography } from '@mui/material';

import { Episode } from '@/types';

export const WarningBanners = ({
  episode,
  isEpisodeNotNasba = false,
}: {
  episode: Episode;
  isEpisodeNotNasba?: boolean;
}) => {
  return (
    <>
      {episode.isArchived && (
        <Alert severity="warning" sx={{ my: 2 }}>
          <Typography variant="body3">
            This episode has been archived
          </Typography>
        </Alert>
      )}
      {isEpisodeNotNasba && (
        <Alert severity="warning" sx={{ my: 2 }}>
          <Typography variant="body3">
            This episode is NOT NASBA QAS Self-Study Sponsor Qualified
          </Typography>
        </Alert>
      )}
    </>
  );
};
